module.exports = __webpack_public_path__ + "static/media/BGMain.1aba58c5.svg";